import { MainPage } from "@src/pages/MainPage";

export const privateRoutes = [
    {
      path: '/',
      Page: MainPage,
    },
];